module.exports = __webpack_public_path__ + "img/fron-04.4d80aae9.jpg";